import { configureStore, combineReducers } from 'redux-starter-kit';
import { userSlice, userActions } from './Stores/UserStore';
import { drawTicketActions, drawTicketSlice } from './Stores/DrawTicketStore';
import { entrySlice, entryActions } from './Stores/EntryStore';
import { loadingSlice, loadingActions } from './Stores/LoadingStore';
import { winnerSlice, winnerActions } from './Stores/WinnerStore';
import { feedbackSlice, feedbackActions } from './Stores/FeedbackStore';
import { gameSlice, gameActions } from './Stores/GameStore';
import {
    notificationSlice,
    notificationActions,
} from './Stores/NotificationStore';

export const createStore = () => {
    return configureStore({
        reducer: combineReducers({
            user: userSlice.reducer,
            drawTicket: drawTicketSlice.reducer,
            entry: entrySlice.reducer,
            loading: loadingSlice.reducer,
            winner: winnerSlice.reducer,
            feedback: feedbackSlice.reducer,
            game: gameSlice.reducer,
            notification: notificationSlice.reducer,
        }),
    });
};

export const actionsStore = dispatch => {
    return {
        userActions: userActions(dispatch),
        drawTicketActions: drawTicketActions(dispatch),
        entryActions: entryActions(dispatch),
        loadingActions: loadingActions(dispatch),
        winnerActions: winnerActions(dispatch),
        feedbackActions: feedbackActions(dispatch),
        gameActions: gameActions(dispatch),
        notificationActions: notificationActions(dispatch),
    };
};

export const mapStateToProps = ({
    user,
    drawTicket,
    entry,
    loading,
    winner,
    feedback,
    game,
    notification,
}) => ({
    user,
    drawTicket,
    entry,
    loading,
    winner,
    feedback,
    game,
    notification,
});
export const mapDispatchToProps = dispatch => {
    return {
        actions: actionsStore(dispatch),
    };
};
